// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609022034/js/" + chunkId + "." + {"44":"b6448608","225":"03baa5f6","481":"c08403cc","486":"0a9a13e0","770":"3a6a9c1c"}[chunkId] + ".0.5595622608279485.chunk.js";
};